<template>
  <div style="display: flex;">
    <div class="tim_userlist">
      <div class="itmes" :class="nowUserID == item.profile.userID ? 'active' : ''"
        v-for="(item, index) in nowFriendList" :key="index" @click="getUserInfo(item)">
        <div class="items_img">
          <img :src="item.profile.avatar" alt="" srcset="">
        </div>
        <div class="items_cont">
          <div class="items_top">
            <div class="items_name">{{ item.profile.nick }}</div>
          </div>
        </div>
      </div>
      <div class="kongts" v-if="nowFriendList.length == ''">
        <div>
          <img src="../../assets/tim/leftkong.png" alt="" srcset="">
          <div class="texts">
            暂无联系人
          </div>
        </div>
      </div>
    </div>
    <div class="boy" v-if="nowUserInfo.profile">
      <div v-loading="loading">
        <div class="boy_top">
          <div class="boy_left">
            <el-image v-if="zhanshiinfo.avatar" class="uimg" :src="zhanshiinfo.avatar" alt="" srcset=""></el-image>
            <div class="boy_right">
              <div class="z_flex">
                <div class="uname">{{ zhanshiinfo.nickname }}</div>
                <img v-if="ishaoyou" src="../../assets/tim/q.png" alt="" srcset=""
                  @click="handlerHaoyou(nowUserInfo.profile.userID, 1)">
                <img v-else src="../../assets/tim/j.png" alt="" srcset=""
                  @click="handlerHaoyou(nowUserInfo.profile.userID, 2)">
              </div>
              <div class="z_flex bom" v-if="nowUserInfo.userID!='xj1'">
                <div>ip：{{ zhanshiinfo.city }}</div>
              </div>
            </div>
          </div>
          <div class="btn_detail" @click="goDetail()" v-if="nowUserInfo.userID!='xj1'">
            查看详情
          </div>
        </div>
        <div class="js" v-if="nowUserInfo.userID!='xj1'">
          <div style="width: 90px;">业务介绍：</div>
          <div style="flex: 1;">{{ zhanshiinfo.zyyw_content }}</div>
        </div>
        <div class="wuliu" v-if="nowUserInfo.userID!='xj1'">
          <div style="width: 80px;">支持物流：</div>
          <div class="wuliur">
            <div v-for="(item, index) in zhanshiinfo.logistics_names" :key="index">
              <span style="margin: 10px;">{{ item }}</span>
            </div>
          </div>
        </div>
        <div class="btn" @click.stop="gohuihuaNow()">
          在线咨询
        </div>
      </div>
    </div>
    <div class="kongts1" v-else>
      <div>
        <img src="../../assets/tim/rightkong.png" alt="" srcset="">
        <div class="texts">
          暂无信息
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSupplierDetail, jhaoyou, shaoyou } from '@/api/index.js'
export default {
  props: {
    FriendList: {
      type: Array,
    }
  },
  name: '',
  data() {
    return {
      nowFriendList: [],
      nowUserInfo: {},
      nowUserID: '',//当前要发送消息的人的id
      ishaoyou: false,
      zhanshiinfo: {},
      loading: false
    }
  },
  watch: {
    FriendList: {
      handler(newVal, oldVal) {
        //监听info对象变化
        if (newVal) {
          this.nowFriendList = newVal
        }
      },
    },
  },
  methods: {
    //查看详情
    goDetail() {
      //如果当前就在详情页 并且与要跳转的id一直就直接关闭弹窗
      let routerid = this.$route.query.id
      if (this.zhanshiinfo.id == routerid) {
        this.$emit('close')
      } else {
        this.$router.push({ path: "/gydetail", query: { id: this.zhanshiinfo.id } })
        this.$emit('close')
      }
    },
    getUserInfo(item) {
      this.loading = true
      this.nowUserID = item.profile.userID
      this.isFriend(item.profile.userID)
      this.nowUserInfo = item
      let toid = item.profile.userID.substring(2)
      getSupplierDetail({ supplier_id: toid }).then(res => {
        if (res.code == 1) {
          this.zhanshiinfo = res.data
          this.loading = false
        }
      })
    },
    //去聊天
    gohuihuaNow() {
      this.$emit('gohuihuaNow', this.nowUserInfo.profile)
    },
    //检测是否是好友
    isFriend(userID) {
      let that = this
      let promise = that.tim.checkFriend({
        userIDList: [userID],
        type: that.TIM.TYPES.SNS_CHECK_TYPE_SINGLE,
      });
      promise.then(function (imResponse) {
        const { successUserIDList, failureUserIDList } = imResponse.data;
        if (successUserIDList[0].relation == 'CheckResult_Type_AWithB') {
          that.ishaoyou = true
        } else {
          that.ishaoyou = false
        }
      }).catch(function (imError) {
        console.warn('checkFriend error:', imError);
      });
    },
    handlerHaoyou(userID, type) {
      let that = this
      if (type == 1) {
        let promise = that.tim.deleteFriend({
          userIDList: [userID],
          type: that.TIM.TYPES.SNS_DELETE_TYPE_BOTH
        });
        promise.then(function (imResponse) {
          that.nowUserInfo = {}
          that.ishaoyou = false
          shaoyou({ collect_id: userID.substring(2) }).then(res => {
            console.log(res);
          })
        }).catch(function (imError) {
          console.warn('removeFromFriendList error:', imError);
        });

      } else {
        let promise = that.tim.addFriend({
          to: userID,
          source: 'AddSource_Type_Web',
          type: that.TIM.TYPES.SNS_ADD_TYPE_SINGLE
        });
        promise.then(function (imResponse) {
          that.ishaoyou = true
          jhaoyou({ collected_id: userID.substring(2) }).then(res => {
            console.log(res);
          })
        }).catch(function (imError) {
          console.warn('removeFromFriendList error:', imError);
        });
      }
    },
  },
}
</script>
<style lang='scss' scoped>
.kongts {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 250px;
  height: 700px;
  text-align: center;

  img {
    width: 42px;
    height: 42px;
  }

  .texts {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ADAAAA;
    line-height: 46px;
  }

}

.kongts1 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 700px;
  text-align: center;
  width: 790px;

  img {
    width: 224px;
    height: 224px;
  }

  .texts {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ADAAAA;
    line-height: 46px;
  }
}

.tim_userlist {
  border-right: 1px solid #eee;
  width: 250px;
  height: 700px;
  overflow: hidden;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  // 滚动条里面的小方块，能向上向下移动（或往左往右移动，取决于是垂直滚动条还是水平滚动条）
  &::-webkit-scrollbar-thumb {
    background: rgba(144, 147, 153, 0.3);
    cursor: pointer;
    border-radius: 4px;
  }

  .active {
    background-color: #eee !important;
  }

  .itmes {
    width: 220px;
    display: flex;
    margin: 14px auto;
    box-sizing: border-box;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 10px;
    align-items: center;

    .items_img {
      width: 40px;
      height: 40px;
      border-radius: 10px;

      img {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
    }

    .items_cont {
      flex: 1;
      margin-left: 9.2px;
    }

    .items_top {
      display: flex;
      justify-content: space-between;
      align-content: center;

      .items_name {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
      }

      .items_time {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #ADAAAA;
      }


    }

    .items_text {
      width: 140px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #ADAAAA;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .itmes:hover {
    background: #f4f4f4;
  }
}


.boy {
  width: 780px;
  padding: 70px 55px;
  box-sizing: border-box;
  height: 700px;

}

.z_flex {
  display: flex;
  align-items: center;
}

.boy_top {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .boy_left {
    display: flex;
    align-items: center;

    .uimg {
      width: 110px;
      height: 110px;
      border-radius: 55px;
    }

    .boy_right {
      margin-left: 30px;

      img {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }

      .uname {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #000000;
        line-height: 28px;
        margin-right: 20px;
      }

      .bom {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #757575;
        line-height: 19px;
        margin-top: 20px;
      }
    }
  }

  .btn_detail {
    width: 160px;
    height: 50px;
    background: #F7F8FA;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #ADAAAA;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 50px;
    text-align: center;
    cursor: pointer;

  }
}

.js {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  line-height: 19px;
  margin-top: 24px;
  display: flex;
  flex-wrap: wrap;

}

.wuliu {
  display: flex;
  margin-top: 10px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #E38111;
  line-height: 19px;

  .wuliur {
    display: flex;
    flex-wrap: wrap;
    flex: 1;
  }
}

.imglist {
  display: flex;
  justify-items: center;
  margin-top: 24px;

  img {
    width: 220px;
    height: 200px;
    border-radius: 10px 10px 10px 10px;
    margin-right: 10px;
  }
}

.btn {
  width: 406px;
  height: 62px;
  background: #FFDB0C;
  border-radius: 10px 10px 10px 10px;
  margin: 200px auto 0px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  line-height: 62px;
  text-align: center;
}
.btn:hover{
  background: #FFED86 !important;
  cursor: pointer;
}
</style>